export default "__VITE_ASSET__onM9bwb2__"